import { DashboardLayout } from 'components/layout/LoggedIn/DashboardLayout'
import { ReadingList as ReadingListComponent } from 'experiences/dashboard/ReadingList'
import { NextPage } from 'next'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { useLoginRequired } from 'services/Authentication/hooks/useLoginRequired'

const ReadingList: NextPage<PageProps> = ({ metaTags }): JSX.Element => {
	useLoginRequired()

	return (
		<StandardLayout metaTags={metaTags}>
			<DashboardLayout ssrDisplay={true}>
				<ReadingListComponent />
			</DashboardLayout>
		</StandardLayout>
	)
}
export const getServerSideProps = defaultSSRProps

export default ReadingList
